import * as moment from "moment";

export function formatToHHmmss_ss(seconds: number): string {
    const hundredths = Math.round(seconds * 100 - Math.floor(seconds) * 100);
    seconds = Math.floor(seconds);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    const result = [];

    result.push(hours);
    result.push(minutes % 60);
    result.push(seconds % 60);

    for (let i = 0; i < result.length; i++) {
        const x = result[i];

        if (x < 10) {
            result[i] = "0" + x;
        } else {
            result[i] = x;
        }
    }

    let resultString = result.join(":");

    let hundredthsString;
    if (hundredths < 10) {
        hundredthsString = "0" + hundredths;
    } else {
        hundredthsString = hundredths;
    }

    resultString += "." + hundredthsString;

    return resultString;
}

const hourMinuteSecHundrethOfSecRegex = /(([01][0-9])|(2[0-3])):[0-5][0-9]:[0-5][0-9]\.[0-9][0-9]/;

export function subtractFormattedTimesWithHundrethsOfSec(
    timeLater: string,
    timeSooner: string
): string {
    if (
        !hourMinuteSecHundrethOfSecRegex.test(timeLater) ||
        !hourMinuteSecHundrethOfSecRegex.test(timeSooner)
    ) {
        throw new Error("Invalid time format of one of the passed time arguments.");
    }

    const [tLater, hunLaterStr] = timeLater.split(".");
    const [tSooner, hunSoonerStr] = timeSooner.split(".");
    const [hLater, minLater, secLater] = tLater.split(":").map(Number);
    const [hSooner, minSooner, secSooner] = tSooner.split(":").map(Number);

    const hunLater = Number(hunLaterStr);
    const hunSooner = Number(hunSoonerStr);

    const decrementSeconds = hunLater < hunSooner;
    const hDiff = hunLater - hunSooner + (decrementSeconds ? 100 : 0);

    const momLater = moment()
        .utc()
        .startOf("day")
        .hour(hLater)
        .minute(minLater)
        .second(secLater);

    const momSooner = moment()
        .utc()
        .startOf("day")
        .hour(hSooner)
        .minute(minSooner)
        .second(secSooner);

    const momLaterDiffSooner = moment(momLater.diff(momSooner)).utc();

    if (decrementSeconds) {
        momLaterDiffSooner.second(momLaterDiffSooner.second() - 1);
    }

    return `${momLaterDiffSooner.format("HH:mm:ss")}.${hDiff < 10 ? "0" : ""}${hDiff}`;
}

export const HHmmssToTotalSeconds = (time: string) => {
    return moment.duration(time).asSeconds();
}

export const isoToHHmmss = (timeISO: string): string => {
    if (!timeISO) return null;

    return moment.duration(timeISO).format("HH:mm:ss");
}
